module.exports = __webpack_public_path__ + "static/img/tx_trend.f2363e44.png";